import ArrowUpDownIcon from '@src/components/icons/ArrowUpDown'
import { createContextLogger } from '@src/utils'

const logger = createContextLogger('ToggleRampDirection')

export type RampDirection = 'ONRAMP' | 'OFFRAMP'

interface IToggleRampDirectionProps {
    onToggleRampDirection: () => void
    direction: RampDirection
}

export function ToggleRampDirection({ onToggleRampDirection, direction }: IToggleRampDirectionProps) {
    const handleClick = () => {
        logger.debug(`Toggling direction from ${direction}`)
        onToggleRampDirection()
    }

    return (
        <div className='relative'>
            <div className='absolute left-1/2 flex h-[34px] w-[34px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#0F1011]'>
                <div
                    className='flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-[#16171A]'
                    onClick={handleClick}
                    title={direction === 'ONRAMP' ? 'Switch to Offramp' : 'Switch to Onramp'}
                >
                    <ArrowUpDownIcon />
                </div>
            </div>
        </div>
    )
}
